import { toFieldCategory } from '@atlassian/jira-common-rest/src/internal/simplified/1.0/projects/id/issuetypes/id/types.tsx';
import type { Panel } from '../../types/layout-items.tsx';
import type { PanelItemFragment as GraphqlPanelItem } from '../fragments/__generated_apollo__/PanelItemFragment';
import type { PanelTransformer } from './types.tsx';

const defaultPanelOperations = {
	editable: false,
	removable: false,
	categoriesWhitelist: [],
	canAssociateInSettings: true,
	deletable: false,
} as const;

/**
 * Transform panel data from GraphQL into a SWIFT compatible {@link Panel} object.
 */
export const transformPanel: PanelTransformer = (panel: GraphqlPanelItem): Panel => {
	const {
		panelItemId,
		name,
		operations: { __typename, categoriesWhitelist, ...cleanOperations },
	} = panel;

	return {
		// TODO MCD-2079 We need a proper key that we can use on the FE to distinguish between panel types
		key: panelItemId,
		name,
		operations: {
			...defaultPanelOperations,
			...cleanOperations,
			categoriesWhitelist: categoriesWhitelist.map(toFieldCategory),
		},
	};
};
